import React from "react";
import PageShell from "@/components/PageShell";

/**
 * Privacy Policy stub. Edit the dates and contact details before going live.
 */
const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2
      className="text-[#FFC800] text-xs tracking-[0.3em] uppercase font-bold mb-3"
      style={{ fontFamily: '"JetBrains Mono", monospace' }}
    >
      {title}
    </h2>
    <div
      className="text-neutral-300 text-sm leading-relaxed space-y-3"
      style={{ fontFamily: '"Manrope", sans-serif' }}
    >
      {children}
    </div>
  </section>
);

export const Privacy = () => {
  return (
    <PageShell>
      <article
        className="max-w-3xl mx-auto px-6 py-10 lg:py-14"
        data-testid="privacy-page"
      >
        <div
          className="text-[10px] text-neutral-500 tracking-[0.3em] uppercase mb-2"
          style={{ fontFamily: '"JetBrains Mono", monospace' }}
        >
          Legal
        </div>
        <h1
          className="text-white text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight leading-none mb-2"
          style={{ fontFamily: '"Barlow Condensed", sans-serif' }}
        >
          Privacy <span className="text-[#FFC800]">Policy</span>
        </h1>
        <div
          className="text-[10px] text-neutral-500 tracking-[0.2em] uppercase mb-10"
          style={{ fontFamily: '"JetBrains Mono", monospace' }}
        >
          Last updated: 30 April 2026
        </div>

        <Section title="Who we are">
          <p>
            Random Six Siege ("we", "us") is a free fan-made web tool that randomises
            operator picks for the video game Tom Clancy's Rainbow Six Siege. We are not
            affiliated with, endorsed by, or sponsored by Ubisoft. The site is hosted at
            randomsixsiege.co.uk.
          </p>
        </Section>

        <Section title="What information we collect">
          <p>
            We try to collect as little as possible. The only data your browser sends to
            us is:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>An anonymous viewer heartbeat (a random ID generated on your device) so we can show a live viewer count to the site owner.</li>
          </ul>
          <p>
            We do <strong>not</strong> ask for your name, email, or any account details.
            There are no user accounts on this site.
          </p>
        </Section>

        <Section title="Cookies and similar technologies">
          <p>
            The site itself does not set tracking cookies. Your browser stores your
            selected settings (such as roll style and team size) locally on your own
            device using <em>localStorage</em> — that information never leaves your
            browser. You can clear it any time using your browser settings.
          </p>
        </Section>

        <Section title="Third-party services">
          <p>We use the following services that may collect data on our behalf:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              <strong>Hosting / infrastructure providers</strong> handle normal traffic
              delivery in the background.
            </li>
          </ul>
        </Section>

        <Section title="Children">
          <p>
            This site is not directed at children under 13. We do not knowingly collect
            personal data from children. If you believe a child has provided us with data,
            contact us and we will delete it.
          </p>
        </Section>

        <Section title="Your rights">
          <p>
            If you live in the EU/UK, GDPR/UK-GDPR gives you the right to access, correct,
            or erase any personal data we hold about you. Because we don't run accounts
            and we don't store any identifying information, in practice there's nothing
            on file tied to you. If you have a specific request, get in touch.
          </p>
        </Section>

        <Section title="Contact">
          <p>
            Questions about this policy? Email{" "}
            <span className="text-[#FFC800]">contact@randomsixsiege.co.uk</span>.
          </p>
        </Section>

        <Section title="Changes">
          <p>
            We may update this policy from time to time. Material changes will be flagged
            on this page with a new "last updated" date.
          </p>
        </Section>
      </article>
    </PageShell>
  );
};

export default Privacy;
